import React from 'react'

type Props = {
  className?: string
}

const Arrow = ({ className }: Props) => (
  <svg width="64" height="65" viewBox="0 0 64 65" fill="none" className={className}>
    <path d="M32 23.3693V42.036" stroke="#9DC2FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M41.3334 32.7026L32 42.036L22.6667 32.7026"
      stroke="#9DC2FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Arrow
